import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ENgxPrintComponent } from "e-ngx-print";
import { ChartMenuService } from '../service/chart-menu.service';

@Component({
  selector: 'bcac-chart-menu',
  templateUrl: './chart-menu.component.html',
  styleUrls: ['./chart-menu.component.scss']
})
export class ChartMenuComponent implements OnInit {

  @ViewChild("print1", { static: false }) print1Component: ENgxPrintComponent;

  constructor(
    private chartMenuService: ChartMenuService
  ) { }
 
  @Input() chartInstance;

  @Input() fileName: string;
  ngOnInit() { }

  // closePanel(event) {
  //   let el = <HTMLElement>event.target;
  //   if (el) {
  //     el.setAttribute("style", "display:none");
  //   }
  // }
  visible: boolean = false;
  closeDropDownMenu() {
    this.visible = false;
  }
  downloadImage(imageType: string, fileName: string) {
    this.chartMenuService.downloadEchartImage(this.chartInstance, fileName, imageType);
  }
  fullScreen() {
    const element = this.chartInstance.getDom();
    this.chartMenuService.fullScreen(element);
  }
  customPrint() {
    this.chartMenuService.customPrint(this.chartInstance, this.print1Component);
  }

}
